<template>
    <div class="how-it-works-area how-it-works-bg section-space--pb_120">
        <div class="container-fluid container-fluid--cp-150">
            <div class="row align-items-center">
                <div class="col-lg-6 video-popup video-link">

                        <div class="single-popup-wrap">
                            <img class="img-fluid" src="../../assets/img/agency/values1.jpg" alt="">
                            
                        </div>

                </div>
                <div class="col-lg-6">
                    <div class="how-it-works__content text-left section-space--mb_60">
                        <h3 class="section-title font-weight--light mb-15 wow move-up">Our Mission</h3>
                        <div class="text mb-20 wow move-up">Empowering customers and employees to accomplish more</div>
                        <ul class="check-list green-check-list section-space--mb_50 wow move-up">
                            <li class="list-item">People are the greatest asset</li>
                            <li class="list-item">Apply innovation in all aspects of our lives</li>
                            <li class="list-item">Continuous pursuit of improvement and education</li>
                            <li class="list-item">We share in our client's vision</li>
							<li class="list-item">Quality is our focus</li>
                        </ul>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'WhaleioValues',
    };
</script>